// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2kTvp","range":"MonthRangeSwitch_range__13WoW","disabled":"MonthRangeSwitch_disabled__2SdpL"};